export const MessageDirections = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
} as const;
